import { useEffect } from 'react'
import { IEvaluacion } from '../constants';
import { FormControl, RadioGroup } from '@mui/material';

import Divider from '../../Divider';
import FControlLabel from '../../shared/Forms/FControlLabel';


interface Props {
  dataEvaluacion: IEvaluacion;
  handleChange(type: string, value: string | number): void;
  sexo: boolean;
}

const DiasEntrenamiento = ({ dataEvaluacion, handleChange, sexo } : Props) => {

  useEffect(() => {
    if (sexo) {
      handleChange('diasPrioridad', 0);
    }
    if(dataEvaluacion.cantidadDiasEntrenamiento === 5) {
      handleChange('diasPrioridad', 0);
    }
  }, [])

  useEffect(() => {
    if(dataEvaluacion.cantidadDiasEntrenamiento === 5) {
      handleChange('diasPrioridad', 0);
    }
  }, [dataEvaluacion.cantidadDiasEntrenamiento])  

  return (
    <div>
      <div className='text-center'>
        <h2 className="title font-bold mb-2">
          ¿Cuántos días por semana entrenarás?
        </h2>
        <p className="text-slate-500">Seleccione la cantidad de días que entrenará a la semana</p>
        <Divider type="option" />
      </div>
      <div className="row">
        <div className="col-12" style={{ textAlign: 'left' }}>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              value={dataEvaluacion.cantidadDiasEntrenamiento}
              onChange={(ev) => handleChange('cantidadDiasEntrenamiento', Number(ev.target.value))}
            >
              <FControlLabel value={3} size='1.15rem' label="3 veces por semana." fontWeight={500} />
              <FControlLabel value={4} size='1.15rem' label="4 veces por semana." fontWeight={500} />
              <FControlLabel value={5} size='1.15rem' label="5 veces por semana." fontWeight={500} />
              
            </RadioGroup>
          </FormControl>
        </div>
      </div>
      <Divider type="option" />
        {sexo === false && dataEvaluacion.cantidadDiasEntrenamiento === 4 && (
          <div>
            <div className='text-center'>
              <h2 className="title font-bold mb-2">
                ¿Cuantos días deseas priorizar tren inferior?
              </h2>
              <Divider type="option" />
            </div>
            <div className="row">
              <div className="col-12" style={{ textAlign: 'left' }}>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    value={dataEvaluacion.diasPrioridad}
                    onChange={(e) => handleChange('diasPrioridad', e.target.value)}
                  >
                    <FControlLabel value={2} size='1.15rem' label="2 veces por semana." fontWeight={500} />
                    <FControlLabel value={3} size='1.15rem' label="3 veces por semana." fontWeight={500} />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
          </div>
        )}

        <Divider type="option" />
        { sexo === false && dataEvaluacion.cantidadDiasEntrenamiento === 3 && (
          <div>
            <div className='text-center'>
              <h2 className="title font-bold mb-2">
                ¿Qué músculos vas a priorizar?
              </h2>
              <Divider type="option" />
            </div>
            <div className="row">
              <div className="col-12" style={{ textAlign: 'left' }}>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    value={dataEvaluacion.diasPrioridad}
                    onChange={(e) => handleChange('diasPrioridad', e.target.value)}
                  >
                    <FControlLabel value={2} size='1.15rem' label="2 veces pierna y 1 vez torso." fontWeight={500} />
                    <FControlLabel value={3} size='1.15rem' label="3 veces pierna" fontWeight={500} />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
          </div>
        )}
    </div>
  )
}

export default DiasEntrenamiento